// src/js/modules/theme-toggle.js

const initThemeToggle = () => {
  const themeToggleButton = document.getElementById("theme-toggle");
  if (!themeToggleButton) return;

  const updateTheme = (isDark) => {
    // 1. Alterna la clase 'dark' en el <html>
    document.documentElement.classList.toggle("dark", isDark);

    // 2. Guarda la preferencia en localStorage para futuras visitas
    sessionStorage.setItem("theme", isDark ? "dark" : "light");

    // 3. Actualiza la etiqueta ARIA para accesibilidad
    themeToggleButton.setAttribute(
      "aria-label",
      isDark ? "Cambiar al modo claro" : "Cambiar al modo oscuro",
    );
  };

  // Obtenemos la preferencia guardada o la del sistema
  const savedTheme = sessionStorage.getItem("theme");
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

  // Al cargar la página, aplicamos el tema correcto
  updateTheme(savedTheme === "dark" || (savedTheme === null && prefersDark));

  // Añadimos el listener para que el botón funcione al hacer clic
  themeToggleButton.addEventListener("click", () => {
    const isCurrentlyDark = document.documentElement.classList.contains("dark");
    // Invertimos el tema actual al hacer clic
    updateTheme(!isCurrentlyDark);
  });
};

export default initThemeToggle;
